import Hotjar from "vue-hotjar";
import { USER_ROLE } from "@/constants";

const shouldRecord = (userData) => {
  const currentRole = userData?.unsafeMetadata?.quiz?.answers?.are_you_a;
  if (currentRole == null) {
    return true;
  }
  if (typeof currentRole === "string") {
    return currentRole !== "student";
  }
  // Legacy: stored full USER_ROLE object before string ids
  if (typeof currentRole === "object") {
    return currentRole?.translationKey !== USER_ROLE.student.translationKey;
  }
  return true;
};

export function setupHotjar(userData) {
  const isProduction = process.env.NODE_ENV === "production";

  if (!userData || !window.hj || !shouldRecord(userData) || !isProduction) {
    return;
  }

  window.hj("identify", userData.id, {
    email: userData.email,
    plan: userData.plan,
    stripe_customer_id: userData.stripeCustomerId,
    stripe_subscription_id: userData.stripeSubscriptionId,
  });
}

export default function initHotjar(Vue) {
  Vue.use(Hotjar, {
    id: "4982392",
    isProduction: process.env.NODE_ENV === "production",
    snippetVersion: 6,
  });
}
